// extracted by mini-css-extract-plugin
export var reviewForm = "ReviewForm-module--reviewForm--dfhDS";
export var submitted = "ReviewForm-module--submitted--6xZex";
export var confirmation = "ReviewForm-module--confirmation--DtqCG";
export var writeReviewForm = "ReviewForm-module--writeReviewForm--m-+tx";